module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-backForm', {
    attrs: {
      "name": 'back-budget-auto',
      "align": true,
      "btns": _vm.showflag
    },
    on: {
      "save": _vm.saveSet,
      "cancel": _vm.backset
    }
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("BU名称 ")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-select', {
    staticClass: "top-choose z-mid",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getData
    },
    model: {
      value: (_vm.bu_id),
      callback: function($$v) {
        _vm.bu_id = $$v
      },
      expression: "bu_id"
    }
  }, _vm._l((_vm.bu_list), function(item) {
    return _c('z-limitOption', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.bu_name
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "small-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "back-item first"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("检测完成率")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.rate_flag),
      callback: function($$v) {
        _vm.rate_flag = $$v
      },
      expression: "rate_flag"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("开启后每月将检查预算完成率，如未达标则开具罚单")])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rate_flag),
      expression: "rate_flag"
    }],
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("预算完成率")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.min_rate),
      expression: "sub.min_rate"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.sub.min_rate),
      callback: function($$v) {
        _vm.$set(_vm.sub, "min_rate", $$v)
      },
      expression: "sub.min_rate"
    }
  }, _vm._l((_vm.complete_options), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "value": item,
        "label": (item + "%")
      }
    })
  }))], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("自动充值")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.auto_flag),
      callback: function($$v) {
        _vm.auto_flag = $$v
      },
      expression: "auto_flag"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("开启后每月将对该BU进行固定充值")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auto_flag),
      expression: "auto_flag"
    }],
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("充值金额")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.auto_amount),
      expression: "sub.auto_amount"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal number positive",
      "placeholder": "请输入充值金额"
    },
    model: {
      value: (_vm.sub.auto_amount),
      callback: function($$v) {
        _vm.$set(_vm.sub, "auto_amount", $$v)
      },
      expression: "sub.auto_amount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("币")])], 2)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auto_flag),
      expression: "auto_flag"
    }],
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("循环设置")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_vm._v("\n            每月\n            ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-8a0c2abc!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/finance/budget-auto.vue
// module id = 773
// module chunks = 1